import React from 'react';
import PropTypes from 'prop-types';
import deepMerge from 'deepmerge';
import { createMuiTheme } from '@material-ui/core/styles';
import BaseTheme, { structuralTheme } from '../theme';
import { overrides as buttonOverrides } from '../button/nfs';
import { overrides as radioOverrides } from '../radio/nfs';
import { overrides as checkboxOverrides } from '../checkbox/nfs';
import { overrides as dialogOverrides } from '../dialog/nfs';
import { overrides as paperOverrides } from '../paper/nfs';
import { overrides as formLabelOverrides } from '../form-label/nfs';
import { overrides as appBarOverrides } from '../app-bar/nfs';
import { overrides as typographyOverrides } from '../typography/nfs';
import { overrides as breadcrumbsOverrides } from '../breadcrumbs/nfs';
import { overrides as linearProgressOverrides } from '../linear-progress/nfs';
import { overrides as tooltipOverrides } from '../tooltip/nfs';
import { overrides as chipOverrides } from '../chip/nfs';
import { rgb } from '../helpers';
import {
    MIDNIGHT_BLUE,
    WHITE_GREY,
    GREY_BLUE,
    DARK_BLUE
} from '../theme/color';

const overrides = {
    MuiCssBaseline: {
        '@global': {
            body: {
                color: `rgba(${rgb(MIDNIGHT_BLUE)}, 0.74)`,
                backgroundColor: WHITE_GREY
            }
        }
    },
    ...buttonOverrides,
    ...radioOverrides,
    ...checkboxOverrides,
    ...dialogOverrides,
    ...paperOverrides,
    ...formLabelOverrides,
    ...appBarOverrides,
    ...typographyOverrides,
    ...breadcrumbsOverrides,
    ...linearProgressOverrides,
    ...tooltipOverrides,
    ...chipOverrides
};

const palette = {
    primary: {
        main: '#106c92',
        light: GREY_BLUE
    },
    secondary: {
        main: DARK_BLUE,
        light: `rgba(${DARK_BLUE}, 0.68)`
    }
};

export const theme = deepMerge(structuralTheme, { overrides, palette });

const nfsTheme = createMuiTheme(theme);

export default function Theme({ children }) {
    return <BaseTheme theme={nfsTheme}>{children}</BaseTheme>;
}

Theme.propTypes = {
    children: PropTypes.node.isRequired
};
